import React from 'react';
import './textHeader.css';


function StylishHeaderDetail(prop) {
    const orSpace = {
        marginTop: "50px",
        marginBottom: "10px",
        position: "relative"
    }
    
    return (
        <div style={orSpace} className="one">
            <div style={{ fontSize: "x-large", fontWeight: "600" }}>{prop.headerText}</div>
            <div></div>
        </div>
    )
}

export default StylishHeaderDetail;